function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M11,90.4H1l23.9-71.2h50.8L73.1,27h26.5L81.4,47.3l4,20.4h-45l2.5-7.8H21.4L11,90.4z M5.2,87.4h3.7l10.4-30.5h40.8 l11.5-34.7H27.1L5.2,87.4z M44.4,64.6h37.3l-3.5-18.3L92.8,30H72.1l-9.9,29.9H45.9L44.4,64.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 20.9,
  y: 34.7,
  width: 47.6,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 23.4,
  y: 27,
  width: 48,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 17,
  y: 42.5,
  width: 48.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 15,
  y: 50.3,
  width: 48.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 60.9,
  y: 56.9,
  width: 20.6,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 45.4,
  y: 50.3,
  width: 35.2,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 66,
  y: 42.6,
  transform: "matrix(1 5.945344e-03 -5.945344e-03 1 0.2633 -0.4387)",
  width: 15.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 68.4,
  y: 34.7,
  width: 20.7,
  height: 3
})))));

var SvgFlag = function SvgFlag(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/flag.40ed7928.svg";
export { SvgFlag as ReactComponent };